module.exports = __webpack_public_path__ + "c0fde8229ec55ccca283db8cfce29028.jpg";